import * as React from "react";
import { Typography } from "@mui/material";
import Container from "@mui/material/Container";
import { Link } from "react-router-dom";

function Info() {
  return (
    <Container className="info" maxWidth="xl">
      <div className="info-content">
        <div className="text-section">
          <Typography className="title" variant="h6">
            BRIGHTON PSYCH FEST 2026 – FAQ / INFO
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            Where
          </Typography>

          <Typography className="text">
            Multi-venue festival taking place across Brighton. Venues /
            addresses are below.
          </Typography>

          <Typography className="text">
            Ticket gains access to all venues. ***
          </Typography>

          <Typography className="text">
            Your wristband you receive at wristband exchange gains access to all
            stages/venues.***
          </Typography>

          <Typography className="text">
            <strong>Brighton Dome Corn Exchange:</strong>
            <br />
            Royal Pavilion Gardens, Brighton and Hove, Brighton BN1 1EE
          </Typography>

          <Typography className="text">
            <strong>Concorde 2:</strong>
            <br />
            286A Madeira Dr, Brighton and Hove, Brighton BN2 1EN
          </Typography>

          <Typography className="text">
            <strong>Komedia:</strong>
            <br />
            44-47 Gardner St, Brighton and Hove, Brighton BN1 1UN
          </Typography>

          <Typography className="text">
            <strong>Volks:</strong>
            <br />
            3 Madeira Dr, Brighton and Hove, Brighton BN2 1PS
          </Typography>

          <Typography className="text">
            <strong>Patterns:</strong>
            <br />
            10 Marine Parade, Kemptown, Brighton and Hove, Brighton BN2 1TL
          </Typography>

          <Typography className="text">
            <strong>The Hope & Ruin:</strong>
            <br />
            11-12 Queens Rd, Brighton and Hove, Brighton BN1 3WA
          </Typography>

          <Typography className="text">
            <strong>Alphabet:</strong>
            <br />
            11 Dyke Rd, Brighton and Hove, Brighton BN1 3FE
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            Wristband Collection x Festival Hub
          </Typography>

          <Typography className="text">
            Wristband exchange will be at Patterns venue upstairs located at:
            <br />
            10 Marine Parade, Kemptown, Brighton and Hove, Brighton BN2 1TL.
          </Typography>

          <Typography className="text">
            Wristband exchange opening times: 1pm - 10pm
          </Typography>

          <Typography className="text">
            You will need to present your ticket on arrival. To avoid delays,
            please ensure that you have either a paper copy of your e-ticket or
            a PDF download ready on your phone before arrival so that we can
            scan you in.
          </Typography>

          <Typography className="text">
            Wristbands must be collected in person. If you booked as a group,
            please arrive together as you won't be able to collect wristbands on
            behalf of others.
          </Typography>

          <Typography className="text">
            You will not be able to gain entry to any of the venues without a
            festival wristband collected first. If you attempt to show up to a
            venue without a wristband collected you will be asked to go and
            receive a wristband from wristband exchange before entry to any
            Brighton Psych Fest venue.
          </Typography>

          <Typography className="text">
            Tickets will be available to purchase at wristband exchange.
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            Age Restrictions
          </Typography>

          <Typography className="text">
            <strong>Brighton Dome Corn Exchange:</strong> 14+ all U16s must be
            accompanied by an adult.
          </Typography>

          <Typography className="text">
            <strong>Concorde 2:</strong> 14+ all U16s must be accompanied by an
            adult.
          </Typography>

          <Typography className="text">
            <strong>Komedia:</strong> 16+
          </Typography>

          <Typography className="text">
            <strong>Volks:</strong> 14+ before 9:30pm, all U16s must be
            accompanied by an adult. After 9:30pm 18+ only.
          </Typography>

          <Typography className="text">
            <strong>Patterns:</strong> 18+
          </Typography>

          <Typography className="text">
            <strong>The Hope & Ruin:</strong> 18+
          </Typography>

          <Typography className="text">
            <strong>Alphabet:</strong> 18+
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            When
          </Typography>

          <Typography className="text">Friday 04th September 2026.</Typography>
          <Typography className="text">1pm-3am.</Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            Live music line-up
          </Typography>

          <Typography className="text">
            {"Click "}
            <Link to="/line-up">here</Link>
            {" to visit line-up A-Z page.*"}
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            Accessibility
          </Typography>

          <Typography className="text">
            Accessibility information can be found via each venue's website. For
            specific queries or requirements, please contact the venue directly.
          </Typography>

          <Typography className="text">
            <strong>Brighton Dome Corn Exchange:</strong>{" "}
            <Link
              target="_blank"
              to="https://brightondome.org/access/"
              rel="noopener noreferrer"
            >
              https://brightondome.org/access/
            </Link>
          </Typography>

          <Typography className="text">
            <strong>Concorde 2:</strong>{" "}
            <Link
              target="_blank"
              to="https://www.concorde2.co.uk/your-visit#accessibility"
              rel="noopener noreferrer"
            >
              https://www.concorde2.co.uk/your-visit#accessibility
            </Link>
          </Typography>

          <Typography className="text">
            <strong>Komedia:</strong>{" "}
            <Link
              target="_blank"
              to="https://www.komedia.co.uk/visit/accessibility/"
              rel="noopener noreferrer"
            >
              https://www.komedia.co.uk/visit/accessibility/
            </Link>
          </Typography>

          <Typography className="text">
            <strong>Volks:</strong>{" "}
            <Link
              target="_blank"
              to="https://volksclub.co.uk/"
              rel="noopener noreferrer"
            >
              https://volksclub.co.uk/
            </Link>
          </Typography>

          <Typography className="text">
            <strong>Patterns:</strong>{" "}
            <Link
              target="_blank"
              to="https://patternsbrighton.com/accessibility/"
              rel="noopener noreferrer"
            >
              https://patternsbrighton.com/accessibility/
            </Link>
          </Typography>

          <Typography className="text">
            <strong>The Hope & Ruin:</strong>{" "}
            <Link
              target="_blank"
              to="https://www.hope.pub/access/"
              rel="noopener noreferrer"
            >
              https://www.hope.pub/access/
            </Link>
          </Typography>

          <Typography className="text">
            <strong>Alphabet:</strong>{" "}
            <Link
              target="_blank"
              to="https://www.alphabetbrighton.com/accessibility"
              rel="noopener noreferrer"
            >
              https://www.alphabetbrighton.com/accessibility
            </Link>
          </Typography>

          <Typography className="text">
            For any specific accessibility enquiries or if you require a PA
            ticket, please contact{" "}
            <a href="mailto:info@brightonpsychfest.com">
              info@brightonpsychfest.com
            </a>
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            Tickets
          </Typography>

          <Typography className="text">
            Tickets on sale now.{" "}
            <Link
              target="_blank"
              to="https://www.seetickets.com/event/brighton-psych-fest-2026/various-brighton-venues/3476833"
              rel="noopener noreferrer"
            >
              Click here to purchase tickets.
            </Link>
            **
          </Typography>

          <Typography className="text">
            £50 final release - Only a few left
          </Typography>

          <Typography className="text">
            £40 second release - SOLD OUT
          </Typography>

          <Typography className="text">
            £30 first release - SOLD OUT
          </Typography>

          <Typography className="text">
            £24.50 early birds - SOLD OUT.
          </Typography>

          <Typography className="text">* + BOOKING FEES</Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            Getting to the festival
          </Typography>

          <Typography className="text">
            All venues are accessible by foot - parking in Brighton is limited
            so walking or travelling by public transport where possible is
            highly recommended.
          </Typography>

          <Typography className="text">
            Closest Train Station: Queens Rd, Brighton and Hove, Brighton BN1
            3XP
          </Typography>

          <Typography className="text">
            National Express Coach Stop: Brighton Pool Valley Coach Station, BN1
            1NJ
          </Typography>

          <Typography className="text">
            Venues are served by multiple bus routes around the city including:
            1, 1A, 5B, 12X + more - plan your journey using the Brighton and
            Hove Buses route planner:
          </Typography>

          <Typography className="text">
            <Link
              target="_blank"
              to="https://www.buses.co.uk/plan-your-journey"
              rel="noopener noreferrer"
            >
              https://www.buses.co.uk/plan-your-journey
            </Link>
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="text">* Line-up subject to change</Typography>

          <Typography className="text">** plus booking fees</Typography>

          <Typography className="text">
            *** Venue capacities are based on first come first serve so please
            arrive early for specific acts.
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            Bag & camera policy
          </Typography>

          <Typography className="text">
            Large bags, including rucksacks, are not permitted. Each customer
            may bring one small bag no larger than A4. Cloakroom facilities may
            be available depending on the venue.
          </Typography>

          <Typography className="text">
            Audio and video recording cameras are prohibited. Professional
            cameras are not permitted in any venues. If your camera has a
            detachable lens, you will not be allowed to bring it into the venue.
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            Festival Eats
          </Typography>

          <Typography className="text">
            We've partnered with Pommy's Pizza to provide some discounted yummy
            treats on the day. Just show your wristband at Pommy's Pizza for 20%
            off your order!
          </Typography>

          <Typography className="text">
            Just show your valid Brighton Psych Fest 2026 wristband and you will
            receive your discount.
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            Contact
          </Typography>

          <Typography className="text">
            <a href="mailto:info@brightonpsychfest.com">
              info@brightonpsychfest.com
            </a>
          </Typography>
        </div>
      </div>
    </Container>
  );
}

export default Info;